export default {
  actionsColumn: {
    sync: 'Sync',
    syncStarted: 'Sync started!',
  },
  dialogAlert: {
    description:
      'This action could delete data permanently and cannot be undone.',
    okLabel: 'Start sync',
    subDescription1:
      'One-way import allows data to be brought in from an external source.',
    subDescription2:
      'The incoming data replaces any existing data in the system.',
    title: 'Syncing the Device data: one-way import',
  },
  pageHeader: {
    description:
      'You can easily import and export Device data, with seamless asynchronous syncing.',
    title: 'Sync with external IT services',
  },
  preview: {
    addStepperNavigation: {
      title: 'Sync Result',
    },
    previewFile: {
      skipWarning: 'Skipped',
      summaryErrorMessage:
        "Rows with errors haven't been imported, but other rows have been successfully imported. If you want to import the errored rows, please correct the source data.",
      summaryWarningMessage:
        'Some devices were skipped because their serial number was not set or because of duplicate serial numbers.',
    },
  },
  syncResultColumn: {
    allSuccess: 'All Success',
    partialError: 'Partial Error',
    partialSkip: 'Partial Skip',
  },
  tableHeader: {
    addIntegration: 'Add integration',
    title: 'Integrated IT service',
  },
};
